import React from 'react';
import OnboardingShell from './components/OnboardingShell';

export default function App() {
  return (
    <div className="min-h-screen bg-brand-bg flex flex-col items-center justify-center p-4 sm:p-8">
      <div className="w-full max-w-4xl">
        <header className="mb-8 text-center flex flex-col items-center">
          <div className="w-24 h-24 flex items-center justify-center mb-4">
            <img src="https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2UvcG5n/14d14dc0100011f20de8b02234a5b726.png" alt="RepUpgrade Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-2xl sm:text-3xl text-brand-deep">RepUpgrade</h1>
          <p className="text-brand-signal mt-2 font-light">by Digital Cowboy</p>
        </header>
        
        <main>
          <OnboardingShell />
        </main>

        <footer className="mt-12 text-center text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Digital Cowboy. Secure setup environment.
        </footer>
      </div>
    </div>
  );
}